import { data as source } from '../downloaded/centertraits.mjs';

export const centertraits = [];
for (const row of source) {
  let { name, ty, effect } = row;

  centertraits.push({
    name,
    ty,
    effect,
  });
}
